import "./web.js";
import { SPRest } from "../rest.js";
import { SiteDesigns } from "./types.js";
export { SiteDesigns, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "siteDesigns", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return SiteDesigns(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map